import _ from 'underscore';

export default (function (AvailabilityService, LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    return {
        contactDetails: function contactDetails(step, junction) {
            step('hoContactDetails', true).onNext.goTo('hoContactDetailsComplete').skipOnResumeIf(function (_ref, _ref2) {
                var submission = _ref.value;
                var displayYourInfoStep = _ref2.displayYourInfoStep;
                return !displayYourInfoStep && submission.persons[0] && submission.persons[0].emailAddress1;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Your Info');
            });

            junction('hoContactDetailsComplete');
        },
        coverables: function coverables(step, junction) {
            step('hoPrequalQuestions', true).onNext.goTo('hoYourHome').skipOnResumeIf(function (_ref3, _ref4) {
                var submission = _ref3.value;
                var gatewayportalnewsubmission = _ref4.gatewayportalnewsubmission;

                if (gatewayportalnewsubmission) {
                    return false;
                }
                if (submission.lobData.homeowners && submission.lobData.homeowners.preQualQuestionSets) {
                    var answerValues = _.values(submission.lobData.homeowners.preQualQuestionSets[0].answers);
                    return answerValues.some(function (value) {
                        return value !== null;
                    });
                }
                return false;
            }).isValid(function (model, formValid) {
                return model.aspects.valid && model.aspects.subtreeValid && formValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Qualification');
            });

            step('hoYourHome').onNext.goTo('hoConstruction').skipOnResumeIf(function (_ref5) {
                var submission = _ref5.value;

                return submission.lobData && submission.lobData.homeowners && submission.lobData.homeowners.coverables.yourHome && submission.lobData.homeowners.coverables.yourHome.occupancy;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.ho.wizard.step.Your Home');
            });

            step('hoConstruction').onNext.goTo('hoRating').skipOnResumeIf(function (_ref6) {
                var submission = _ref6.value;
                return submission.lobData.homeowners.coverables.construction;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.ho.wizard.step.Construction');
            });

            step('hoRating').onNext.goTo('hoCoverablesComplete').skipOnResumeIf(function (_ref7) {
                var submission = _ref7.value;

                return _.some(submission.quoteData.offeredQuotes, function (quote) {
                    return quote.status === 'Quoted';
                }) && submission.lobData.homeowners && submission.lobData.homeowners.coverables.rating;
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.ho.wizard.step.Discount');
            });

            junction('hoCoverablesComplete');
        },
        moreInfo: function moreInfo(step, junction) {
            step('hoPolicyInfo', true).onNext.goTo('hoMoreInfoComplete').skipOnResumeIf(function (_ref8) {
                var submission = _ref8.value;

                return submission.baseData && submission.baseData.accountHolder && submission.baseData.accountHolder.emailAddress1 && (submission.baseData.accountHolder.homeNumber || submission.baseData.accountHolder.workNumber || submission.baseData.accountHolder.cellNumber);
            }).isValid(function (model) {
                return model.aspects.valid && model.aspects.subtreeValid;
            }).label(function () {
                return translateFn('quoteandbind.wizard.step.Policy Info');
            });

            junction('hoMoreInfoComplete');
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=ho!./common/js/src/edge/quoteandbind/ho/config/FlowConfig.js
// module id = 475
// module chunks = 0